import { useContext } from "react";

import TableContext from "context/table/tableContext";
import { FILTER_NAMES, TABLE_NAMES } from "shared/types/enums";

import DeviceDetailTwoFilters from "./shared/DeviceDetailTwoFilters";
import {
    CONFIGURATION_CHANGE_ORIGIN,
    CONFIGURATION_TYPE
} from "./shared/DeviceDetailTwoFilters/constants";

export const DeviceDetailConfigChanges = () => {
    const { innerTableQueryParams, tableName } = useContext(TableContext);

    const customTableName = `${TABLE_NAMES.Devices}/${innerTableQueryParams[FILTER_NAMES.DeviceImei]}/${tableName}`;

    return (
        <DeviceDetailTwoFilters
            firstFilter={FILTER_NAMES.Type}
            secondFilter={FILTER_NAMES.Origin}
            firstFilterPlaceholder={CONFIGURATION_TYPE}
            secondFilterPlaceholder={CONFIGURATION_CHANGE_ORIGIN}
            customTableName={customTableName}
        />
    );
};
